export default {
  baseStyle: {
    stroke: 'none',
  },
};
